export default __webpack_public_path__ + "static/media/pickerAndPacker.37d70aa4.svg";